import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import CheckNoticeWidget from '../../../widgets/checkNoticeWidgets/CheckNoticeWidget'
import { getCheckNotice } from '../../../redux/actions/checkNotice'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function CheckNotice() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async (projectVersionId, noticeId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getCheckNotice(projectVersionId, noticeId)
      // console.log('handleGetSchema', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    handleGetSchema(projectId, null)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader
        header={schema?.header || 'จัดทำหนังสือทวงถาม (Notice)'}
        subHeader={schema?.subHeader}
        isNotCallApi
      />

      <CheckNoticeWidget schema={schema} />

      <br />
    </SidebarProposal>
  )
}
